
import React from 'react';

const IntroSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Are you seeking professional third-party coating inspection services?
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              As corrosion costs continue to escalate across industries, maintaining the highest quality of protective coating work has become essential for asset owners. Your bridges, pipelines, storage tanks, industrial facilities, and critical infrastructure demand long-lasting protection with minimal future maintenance requirements.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Independent coating inspection services provide industrial and commercial asset owners with a reliable methodology to mitigate corrosion risks by verifying the quality and compliance of protective coating systems throughout the application process.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Quality verification during surface preparation and coating application—whether for exterior protective coatings or interior lining systems—is critical when structures undergo repair, maintenance, or replacement. HP Inc Consulting Services specializes in providing independent quality control inspections that ensure contractors' quality assurance practices meet specified requirements and industry standards.
            </p>
          </div>
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/83c31d00f47a619d4f0a515f0b3bc954/4f9f648de23e31536c99bd5cd6991a12.jpeg"
              alt="Professional coating inspection process"
              className="rounded-lg shadow-lg w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
